import { render, staticRenderFns } from "./BloodResultIndexComponent.vue?vue&type=template&id=daedffe6"
import script from "./BloodResultIndexComponent.vue?vue&type=script&lang=js"
export * from "./BloodResultIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports